<div id="map-container" class="-ml-4 -mr-4 -mt-2 ">
	<div id="map" leaflet [leafletOptions]="options" [leafletMarkerCluster]="filteredData" >
		
	</div>
<!-- 	<div id="search">	
		<a mdbBtn color="danger" floating="true" size="sm" mdbWavesEffect (click)="search()">
			<i class="fas fa-search"></i>
		</a>
		<div class="animated" [ngClass]="{'fadeInLeft':showSearch,'fadeOutLeft':!showSearch}">
			<div class="md-form md-outline">
				<i class="fas fa-search prefix text-white"></i>
				<input type="text" mdbInput class="form-control" id="searchInput" [(ngModel)]="searchInput" (keyup)="$event.keyCode == 13 ? search() : ''"/>
				<label for="searchInput">Nom, adresse ou code postal</label>
			</div>
		</div>
	</div> -->
	<div id="search">	
		<p-overlayPanel #op>
		    <ng-template pTemplate="content">
		        <input type="text" pInputText id="searchInput" [(ngModel)]="searchInput" (keyup)="$event.keyCode == 13 ? search() : ''" placeholder="Nom, adresse ou code postal" />

		    </ng-template>
		</p-overlayPanel>
		<p-button (click)="op.toggle($event)" icon="pi pi-search"></p-button>
	</div>
</div>